import Image from 'next/image';
import { SORT_ORDER_OPTIONS } from '../_constants';
import { useMyLibraryUrlParams } from '../_hooks/useMyLibraryUrlParams';
import SearchIcon from './search.svg?url';
import SortIcon from './sort.svg?url';
import type { SortOrderKey } from '../_constants';

export const ListFilter: React.FC = () => {
  const { searchQueryString, updateSortOrder, updateSearchQueryString } =
    useMyLibraryUrlParams();
  return (
    <div className="tw-grid tw-max-w-[30rem] tw-grid-cols-[1fr,auto] tw-gap-[1rem]">
      <div className="tw-relative">
        <Image
          src={SearchIcon}
          alt=""
          className="tw-absolute tw-inset-y-0 tw-left-[0.5rem] tw-my-auto tw-h-[1.5rem] tw-w-[1.5rem] tw-opacity-40"
        />
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const form = new FormData(e.currentTarget);
            const newQuery = form.get('query') || ('' as string);

            updateSearchQueryString(newQuery as string);
          }}
        >
          <input
            type="text"
            name="query"
            placeholder="タイトル名で検索"
            className="tw-h-[3rem] tw-w-full tw-rounded-4 tw-border-[2px] tw-border-base-lv4 tw-p-[0.5rem] tw-pl-[2.5rem]"
            defaultValue={searchQueryString}
          />
        </form>
      </div>
      <div className="tw-relative">
        <select
          className="tw-h-[3rem] tw-w-[3rem] tw-appearance-none tw-overflow-hidden tw-bg-none tw-opacity-0"
          onChange={(e) => {
            updateSortOrder(e.target.value as SortOrderKey);
          }}
        >
          {SORT_ORDER_OPTIONS.map(({ key, text }) => (
            <option key={key} value={key}>
              {text}
            </option>
          ))}
        </select>
        <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-h-[3rem] tw-w-[3rem] tw-rounded-4 tw-border-[2px] tw-border-base-lv4">
          <Image
            src={SortIcon}
            alt=""
            className="tw-absolute tw-inset-0 tw-m-auto tw-h-[2rem] tw-w-[2rem]"
          />
        </div>
      </div>
    </div>
  );
};
